var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "geo-wrapper" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "geo", tabindex: "-1", role: "dialog" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", {
                staticClass: "modal-title h3",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("Phywe::Template.PopupHeader")
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("Phywe::Template.PopupBody", {
                      country: _vm.country
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center mt-4"
                },
                [
                  _c("button", {
                    staticClass: "btn btn-primary flex-fill",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate("Phywe::Template.PopupButton")
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.goto()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "btn flex-fill",
                    attrs: {
                      "data-dismiss": "modal",
                      "aria-hidden": "true",
                      href: "#"
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate("Phywe::Template.PopupLink")
                      )
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-5 d-flex justify-content-center" }, [
      _c("img", {
        staticStyle: { "max-width": "270px" },
        attrs: {
          src:
            "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/PHYWE_Logo_mit_Claim_CMYK.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }